import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import { isEmpty } from '../../utils/obj-utils';

function LastOrder({
    lastOrder,
    noOrdersFoundText,
    fileStateValues,
    orderTypeValues,
    onViewLastOrderSummaryClick
}) {
    function handleViewLastOrderSummaryClick(event) {
        event.preventDefault();
        onViewLastOrderSummaryClick(lastOrder.fileNumber);
    }

    const isOrderValid = (order) => !isEmpty(order) && !isEmpty(order.fileNumber);

    return (
        <div className='last-order'>
            <h2>{formMessageConstants.lastOrderText}</h2>
            {isOrderValid(lastOrder) ?
                <Fragment>
                    <div className='my-account-tag'>{orderTypeValues[lastOrder.orderTypeIndex]}</div>
                    <p>
                        <span className='left'>{formMessageConstants.fileNumber}</span>
                        <span className='right'>{lastOrder.fileNumber}</span>
                    </p>
                    <p>
                        <span className='left'>{formMessageConstants.fileStatus}</span>
                        <span className='right'>{fileStateValues[lastOrder.fileStateIndex]}</span>
                    </p>
                    <p>
                        <span className='left'>{formMessageConstants.lastUpdate}</span>
                        <span className='right'>{lastOrder.lastUpdateText}</span>
                    </p>
                    <p>
                        <span className='left'>{formMessageConstants.fileAmount}</span>
                        <span className='right'>{lastOrder.formattedFileAmount}</span>
                    </p>
                    <div className='buttons-container'>
                        <a
                            className='yellow-button'
                            href='#'
                            onClick={handleViewLastOrderSummaryClick}
                        >{formMessageConstants.seeDetails}</a>
                    </div>
                </Fragment> :
                <div className='no-files'>
                    <p className='info'>{noOrdersFoundText}</p>
                </div>
            }
        </div>
    );
}

LastOrder.propTypes = {
    lastOrder: PropTypes.object.isRequired,
    noOrdersFoundText: PropTypes.string.isRequired,
    fileStateValues: PropTypes.object.isRequired,
    orderTypeValues: PropTypes.object.isRequired,
    onViewLastOrderSummaryClick: PropTypes.func.isRequired,
};

export default LastOrder;
